import { isNumeric } from '../../util/helpers';
import { ReviewSummary } from '../../shared/models/review-summary.model';
import { ApproachType } from './approach-type.model';
import { AirportFuelSummary } from './airport-fuel-summary.model';
import { parseLatLon } from '../util/parseUtils';
import { Airport } from './airport.model';
/**
 * Model for airport search result. This class contains basic information about the airport, and just enough
 * information to enable client-side filtering on supported search criteria.
 */
var AirportSearchResult = /** @class */ (function () {
    function AirportSearchResult() {
    }
    Object.defineProperty(AirportSearchResult.prototype, "identifier", {
        /**
         * Gets the identifier that should be displayed for this airport. This will either be the ICAO identifier if
         * available, or the FAA identifier otherwise.
         */
        get: function () {
            return this.icaoId || this.faaId || '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses an airport search result as returned by the API into an instance of the AirportSearchResult class.
     */
    AirportSearchResult.parse = function (data) {
        return Object.assign(new AirportSearchResult(), {
            airportId: data.airportId,
            faaId: data.faaId,
            icaoId: data.icaoId,
            type: Airport.parseAirportType(data.type),
            airportOwnership: Airport.parseAirportOwnershipType(data.airportOwnership),
            status: Airport.parseAirportStatus(data.status),
            name: data.name,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            country: data.country || null,
            publicUse: Airport.parsePublicUse(data.airportUsage),
            militaryJoint: data.militaryJoint,
            location: data.location ? parseLatLon(data.location.latitude, data.location.longitude) : null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            towered: data.towerPresent,
            maxRunwayLength: isNumeric(data.maxRunwayLength) ? +data.maxRunwayLength : null,
            reviewSummary: data.reviewSummary ? ReviewSummary.parse(data.reviewSummary) : null,
            customsIntlEntry: data.customsIntlEntry,
            rentalCar: data.rentalCars,
            oxygen: data.oxygen,
            approaches: AirportSearchResult.parseApproaches(data.approaches),
            fuel: (data.fuel || []).map(function (f) { return AirportFuelSummary.parse(f); }),
            paved: data.paved,
            helipad: data.helipad,
            waterway: data.waterway,
            grass: data.grass,
            airframeRepair: data.airframeRepair,
            engineRepair: data.engineRepair,
            avionicsRepair: data.avionicsRepair,
            restaurantOnField: data.restaurantOnField,
            campingOnField: data.campingOnField,
            courtesyCar: data.courtesyCar,
            landingFee: data.landingFee,
            minPriceType: null,
            minPrice: null,
            sourceId: data.sourceId
        });
    };
    /**
     * Parses approaches available at airport
     * @param approaches {Array<string>} Approaches as returned by API
     * @return {Array<ApproachType>} Parsed approach types
     */
    AirportSearchResult.parseApproaches = function (approaches) {
        if (!approaches || approaches.length < 1) {
            return [];
        }
        return (approaches || []).map(function (apch) {
            switch (apch) {
                case 'ILS':
                    return ApproachType.ILS;
                case 'RNAV':
                    return ApproachType.RNAV;
                case 'VOR':
                    return ApproachType.VOR;
                default:
                    return null;
            }
        }).filter(function (v) { return v; });
    };
    return AirportSearchResult;
}());
export { AirportSearchResult };
